import React, { useEffect, useState } from 'react';

import { compose } from 'redux';
import { connect, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { Fab, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { withStyles } from '@mui/styles';
import AddIcon from '@mui/icons-material/Add';
import PropTypes from 'prop-types';

import { FEATURE_FIELDS } from './create.container';
import { GET_PRODUCT_VERSIONS_SUCCESS, getProductVersions } from './productVersions.actions';
import { PERMISSIONS } from '../auth/constants';
import { PermissionCheck } from '../auth/permissionCheck.component';
import { handleToastMessage, setPageTitle } from '../layout/layout.actions';

let ProductVersionsList = ({ classes, history, setPageTitle }) => {
  const [productVersions, setProductVersions] = useState();
  const [isLoading, setLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(async () => {
    setPageTitle('Product Versions');
    const res = await dispatch(getProductVersions());
    if (res.type === GET_PRODUCT_VERSIONS_SUCCESS) {
      setProductVersions(res.response.productVersions);

      setLoading(false);
    } else {
      dispatch(handleToastMessage('Failed to load product versions'));
    }
  }, []);

  if (!productVersions) {
    return <div className="loader" />;
  }

  return (
    <div style={{ display: 'flex', flex: 1, flexDirection: 'column', height: '75vh', paddingTop: 10, overflowY: 'auto' }}>
      {isLoading && <div className="loader" />}
      {!isLoading &&
        <div className={classes.tableWrapper} id="tableWrapper">
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell className={classes.head}>
                  Product Version
                </TableCell>
                <TableCell className={classes.head}>
                  <div>Hardware Type</div>
                </TableCell>
                <TableCell className={classes.head}>
                  <div>Usage Event Type / Name</div>
                </TableCell>
                <TableCell className={classes.head}>
                  <div>Features</div>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody className={classes.tableBody}>
              {productVersions.map(productVersion => (
                <TableRow key={productVersion.code}>
                  <TableCell className={classes.cell}>
                    {productVersion.code}
                  </TableCell>
                  <TableCell className={classes.cell}>
                    {productVersion.podHardwareType}
                  </TableCell>
                  <TableCell className={classes.cell}>
                    {!productVersion.locationUsageEventType && 'N/A'}
                    {productVersion.locationUsageEventType && (
                      <div>
                        {productVersion.locationUsageEventType} / {productVersion.locationUsageEventName}
                      </div>
                    )}
                  </TableCell>
                  <TableCell className={classes.cell}>
                    {Object.keys(productVersion)
                      .filter(key => FEATURE_FIELDS.includes(key))
                      .filter(key => productVersion[key] === true)
                      .join(', ')
                    }
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      }
      {!isLoading &&
        <PermissionCheck require={PERMISSIONS.PRODUCT_VERSIONS_CREATE}>
          <div style={{ flex: 0 }}>
            <Fab
              color="primary"
              aria-label="Add"
              className={classes.addButton}
              onClick={() => history.push('/productVersions/create')}
            >
              <AddIcon />
            </Fab>
          </div>
        </PermissionCheck>
      }
    </div>
  );
};

const styles = theme => ({
  table: {
    minWidth: 1024,
    padding: 20,
  },
  tableWrapper: {
    padding: '1rem',
  },
  tableBody: {
    overflowY: 'auto',
    height: '75vh',
  },
  head: {
  },
  cell: {
  },
  addButton: {
    margin: theme.spacing(1),
    position: 'absolute',
    bottom: 10,
    right: 10,
  },
});

ProductVersionsList.propTypes = {
  setPageTitle: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

const prepareForExport = compose(
  withStyles(styles, { withTheme: true }),
  withRouter,
  connect(
    null,
    {
      setPageTitle,
    }
  ),
);

export default prepareForExport(ProductVersionsList);